<template>
  <base-drawer
    title="应用编辑"
    @close="close"
    :visible="visible"
    :offset="false"
  >
    <template v-slot:operate>
      <a-button
        type="primary"
        @click="save"
      >保存</a-button>
    </template>
    <a-form :form="editAppForm">
      <a-row>
          <a-form-item label="审核状态" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" style="margin-bottom: -4px">
            <icon-font v-if="statusDescription==='通过'" type="icon-check-circle-fill" style="color: #52C41A;"></icon-font>
            <span :class="checkStatusClassObject">{{statusDescription}}</span>
          </a-form-item>
      </a-row>
      <a-row >
          <a-form-item label="应用编号" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" style="margin-bottom: -4px">
            {{id}}
          </a-form-item>
      </a-row>
      <a-row>
          <a-form-item label="应用秘钥" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" style="margin-bottom: 6px">
            {{appKey}}
            <span style="color: #178FFF;font-size: 14px;margin-left: 12px" @click="resetAppKey">{{resetAppKeyTips}}</span>
          </a-form-item>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="应用名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <a-input
              placeholder="请输入应用名称"
              v-decorator="['appName', {rules: [{ required: true, message: '请输入应用名称' }] }]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="应用备注" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入应用备注"
              v-decorator="['comments']"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="应用域名" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <a-input
              placeholder="请输入应用域名"
              v-decorator="['domain', {rules: [{ required: true, message: '请输入应用域名' }] }]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="网站ICP备案" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入网站ICP备案"
              v-decorator="['icp', {rules: [{ required: true, message: '请输入网站ICP备案' }] }]"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </base-drawer>
</template>

<script>
import BaseDrawer from '@/components/BaseDrawer.vue';
import { updateApp, getApp, applyResetAppKey } from '@/services/modules/app-manage';
import { Form, Row, Col } from 'ant-design-vue';

export default {
  name: 'AppDetailDrawer',
  props: ['visible', 'id'],
  components: {
    'a-form': Form,
    'a-form-item': Form.Item,
    'a-row': Row,
    'a-col': Col,
    BaseDrawer,
  },
  data() {
    return {
      editAppForm: this.$form.createForm(this, { name: 'edit-app' }),
      statusDescription: '',
      appKey: '',
      resetAppKeyTips: '重置申请',
    };
  },
  computed: {
    checkStatusClassObject() {
      if (this.statusDescription === '通过') {
        return 'checkedSucceed';
      }
      if (this.statusDescription === '审核中') {
        return 'unChecked';
      }
      if (this.statusDescription === '审核中') {
        return 'checking';
      }
      if (this.statusDescription === '已禁止') {
        return 'checkForbidden';
      }
      if (this.statusDescription === '未知') {
        return 'unKnown';
      }
      return 'unKnown';
    },
  },
  mounted() {
    this.getAppInfo();
  },
  watch: {
    id() {
      if (this.visible) {
        this.getAppInfo();
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    save() {
      this.editAppForm.validateFields((err, values) => {
        if (!err) {
          const parameter = values;
          parameter.appId = this.id;
          updateApp(parameter).then((res) => {
            if (res && res.success && res.result) {
              this.$message.success('编辑成功');
              this.$emit('close');
            } else {
              this.$message.error((res && res.errorMessage) || '编辑失败，请重试');
            }
          });
        }
      });
    },
    getAppInfo() {
      if (this.id && this.id.length > 0) {
        const params = { appId: this.id };
        getApp(params).then((res) => {
          if (res && res.success && res.result) {
            setTimeout(() => {
              this.editAppForm.setFieldsValue({ appName: res.result.appName });
              this.editAppForm.setFieldsValue({ comments: res.result.comments });
              this.editAppForm.setFieldsValue({ domain: res.result.domain });
              this.editAppForm.setFieldsValue({ icp: res.result.icp });
            }, 100);
            this.statusDescription = res.result.statusDescription;
            this.appKey = res.result.appKey;
            if (res.result.isResettingAppKey && res.result.isResettingAppKey === 1) {
              this.resetAppKeyTips = '重置处理中...';
            } else {
              this.resetAppKeyTips = '重置申请';
            }
          } else {
            this.$message.error((res && res.errorMessage) || '获取应用信息失败，请重试');
          }
        });
      }
    },
    resetAppKey() {
      if (this.resetAppKeyTips === '重置申请') {
        const parameter = { appId: this.id };
        applyResetAppKey(parameter).then((res) => {
          if (res && res.success && res.result) {
            this.resetAppKeyTips = '重置处理中...';
            this.$message.success('重置申请成功');
          } else {
            this.$message.error((res && res.errorMessage) || '重置申请失败，请重试');
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
  .checkedSucceed {
    margin-left: 8px;
    color: #52C41A;
  }
  .unChecked {
    color: #000000;
  }
  .checking {
    color: #000000;
  }
  .checkForbidden {
    color: #F5222D;
  }
  .unKnown {
    color: #FAAD14;
  }
</style>
